import { tryToGetNumber } from '@rst/libs-ts'
import { ThemeType } from '../theme/create'
import {
	colors,
	ColorsSchemeNames,
	colorsScheme,
	ColorsSchemeCoreNames,
	FullColorNamesType,
} from './color'
import { ColorType } from './types'

export * from './color'
export * from './types'
export * from './core-shades'

/**
 * @deprecated The method should not be used
 */
export const getColor =
	(fn: (color: typeof colors) => string, disableGradient?: boolean) =>
	({ theme }: { theme: ThemeType }) => {
		const color = fn(colors)

		if (disableGradient) {
			const is = color.match(/gradient/g)
			return is ? color.match(/(#.{6})/g)[0] : color
		}

		return (theme?.colors || colorsScheme)[color]
	}

type Params = {
	theme?: boolean
	gradient?: boolean
	opacity?: number
}

type Color = ColorType | ((color: typeof colors) => string)

export { Color as ColorParamType }

type ReturnedColor = (arg: { theme: ThemeType }) => string

/**
 * @deprecated The method should not be used
 */
export function color(c_: Color, params?: Params): ReturnedColor
export function color(
	c_: ColorsSchemeNames | FullColorNamesType,
	params?: Params
): ReturnedColor
export function color(c_: ColorsSchemeCoreNames, params?: Params): ReturnedColor

export function color(inputColor: any, params?: Params) {
	return ({ theme: styledTheme }: { theme: ThemeType }) => {
		let { theme, gradient, opacity } = params || {
			theme: true,
			gradient: false,
			opacity: 1,
		}

		const colorHub = (theme && styledTheme?.colors) || colorsScheme

		let color = ''
		if (typeof inputColor === 'string') {
			const isOpacityColor = /^opacity-/.test(inputColor)
			let _c = inputColor
			if (isOpacityColor) {
				const {
					opacity: calculatedOpacity,
					baseColor,
					index,
				} = findOpacity({
					inputColor,
					defaultOpacity: opacity,
				})
				opacity = calculatedOpacity
				_c = calcOpacityBaseColor({ baseColor, index })
			}
			color = colorHub[_c] || colorsScheme[_c]
		} else if (typeof inputColor === 'function') {
			color = colorHub[inputColor(colors)]
		}

		if (gradient) {
			return gradientFn(color)
		}

		if (opacity >= 0 && opacity < 1) {
			color = `${color}${percentToHex(opacity)}`
		}

		return color
	}
}

export const getColorByHex = (c_: string) => {
	for (let key in colorsScheme) {
		if (c_ === colorsScheme[key]) return key
	}
	return 'none'
}

const findOpacity = ({
	defaultOpacity,
	inputColor,
}: {
	defaultOpacity: number
	inputColor: string
}) => {
	let baseColor = ''
	let index: number | string = 0
	if (/^opacity-gray-to-white-/.test(inputColor)) {
		baseColor = 'gray'
		index = inputColor.slice(22)
	} else {
		const splitted = inputColor.split('-')

		;[, baseColor, index] = splitted
	}

	if (['gray', 'white'].includes(baseColor)) {
		const opacities = [
			0.015, 0.0313726, 0.0509804, 0.101961, 0.14902, 0.2, 0.301961, 0.45098,
			0.54902, 0.65098, 0.8,
		]
		return {
			opacity: opacities[tryToGetNumber(index)] * defaultOpacity,
			baseColor,
			index,
		}
	}
	return { opacity: 0.5 * defaultOpacity, baseColor, index }
}
const calcOpacityBaseColor = ({
	baseColor,
	index,
}: {
	baseColor: string
	index: string
}) => {
	if (baseColor === 'gray') {
		return 'gray-19'
	}
	if (baseColor === 'white') {
		return 'gray-04'
	}
	return `${baseColor}-${index}`
}
const gradientFn = (color: string) =>
	color?.match(/gradient/g) ? color?.match(/(#.{6})/g)[0] : color

const percentToHex = (p: number) => {
	const intValue = Math.round(((p * 100) / 100) * 255)
	const hexValue = intValue.toString(16)
	return hexValue.padStart(2, '0').toUpperCase()
}
